module.exports = __webpack_public_path__ + "static/icymiPodcast-3d64c5db8eac156981f3202b4971983a.jpg";